"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var arrow_1 = __importDefault(require("./assets/arrow"));
var style_1 = require("./style");
var InputButtonWithDateRange = /** @class */ (function (_super) {
    __extends(InputButtonWithDateRange, _super);
    function InputButtonWithDateRange(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnClick = function () {
            if (!_this.props.isControlled) {
                _this.setState({ isInputActive: !_this.state.isInputActive });
            }
            if (_this.props.onInputClick !== undefined) {
                _this.props.onInputClick();
            }
        };
        _this.handleOnDeleteClick = function () {
            var _a = _this.props, hasSelectedValues = _a.hasSelectedValues, isControlled = _a.isControlled, isActive = _a.isActive;
            var isInputActive = _this.state.isInputActive;
            var canDeleteInput = (((isControlled && !isActive) || !isInputActive) && hasSelectedValues === true);
            if (canDeleteInput && _this.props.onCrossClick !== undefined) {
                _this.props.onCrossClick();
            }
        };
        _this.state = {
            isInputActive: (_this.props.isControlled)
                ? _this.props.isActive
                : false
        };
        return _this;
    }
    InputButtonWithDateRange.prototype.render = function () {
        var _a = this.props, hasSelectedValues = _a.hasSelectedValues, isControlled = _a.isControlled, isDisabled = _a.isDisabled, leftIconVariant = _a.leftIconVariant, leftRangeLabel = _a.leftRangeLabel, rightActiveIconVariant = _a.rightActiveIconVariant, rightInactiveIconVariant = _a.rightInactiveIconVariant, rightRangeLabel = _a.rightRangeLabel;
        var isInputActive = this.state.isInputActive;
        var isActive = isControlled ? this.props.isActive : isInputActive;
        var canDeleteInput = !isActive && hasSelectedValues === true;
        var currentRightInactiveIconVariant = canDeleteInput
            ? 'cross'
            : rightInactiveIconVariant !== undefined
                ? rightInactiveIconVariant
                : 'arrow-down';
        return (react_1.default.createElement(style_1.StyledInputButton, { isActive: isActive, isDisabled: isDisabled, leftIconVariant: leftIconVariant !== null && leftIconVariant !== void 0 ? leftIconVariant : 'date', onInputClick: this.handleOnClick, onRightIconClick: this.handleOnDeleteClick, rightActiveIconVariant: rightActiveIconVariant !== null && rightActiveIconVariant !== void 0 ? rightActiveIconVariant : 'arrow-up', rightInactiveIconVariant: currentRightInactiveIconVariant, shouldRightIconClickStopPropagation: canDeleteInput },
            react_1.default.createElement("div", { className: 'InputButtonWithDateRange__content' },
                react_1.default.createElement("p", { className: 'InputButtonWithDateRange__label' }, leftRangeLabel),
                (rightRangeLabel === null || rightRangeLabel === void 0 ? void 0 : rightRangeLabel.length) > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: 'InputButtonWithDateRange__contentIconWrapper' },
                        react_1.default.createElement(arrow_1.default, { className: 'InputButtonWithDateRange__contentArrowIcon' })),
                    react_1.default.createElement("p", { className: 'InputButtonWithDateRange__label' }, rightRangeLabel))) : null)));
    };
    InputButtonWithDateRange.defaultProps = {
        isActive: false,
        isControlled: true
    };
    return InputButtonWithDateRange;
}(react_1.default.Component));
exports.default = InputButtonWithDateRange;
